import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MatSelect } from '@angular/material';
import { EducationPackageService } from 'src/app/services/http/business/educationPackage/education-package.service';
import { IEducationPackage } from 'src/app/interfaces/educationPackage';
import { ICompany } from 'src/app/interfaces/company';
//import { BIDService } from 'src/app/services/common/bid.service';
//import { CIDService } from 'src/app/services/common/cid.service';
import { BranchService } from 'src/app/services/http/business/branch/branch.service';
import { CompanyService } from 'src/app/services/http/business/company/company.service';
import { IBranch } from 'src/app/interfaces/branch';
import { LevelInfoService } from 'src/app/services/http/business/levelInfo/level-info.service';
import { ILevelInfo } from 'src/app/interfaces/levelInfo';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-company-registration-search',
  templateUrl: './company-registration-search.component.html',
  styleUrls: ['./company-registration-search.component.css']
})
export class CompanyRegistrationSearchComponent implements OnInit {

  form: FormGroup;
  eduPackageList: IEducationPackage;
  levelInfoList: ILevelInfo;
  companyList: ICompany[];
  branchList: IBranch[];

  constructor(
    private fb: FormBuilder,
    private eduPackageService: EducationPackageService,
    private levelInfoService: LevelInfoService,
    //private bidService: BIDService,
    //private cidService: CIDService,
    private branchService: BranchService,
    private companyService: CompanyService,
    private dialog: MatDialogRef<CompanyRegistrationSearchComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.createForm();
    this.getEduPackage();
    this.getCompanyList();
  }
  createForm() {
    this.form = this.fb.group({
      CompanyEncryptId: [null],
      BranchEncryptId: [null],
      FullName: [null],
      NationalCode: [null],
      CellPhoneNumber:[null],
      PackageId: [null],
      LevelInfoId: [null],
      RegisterStartDate: [null],
      RegisterEndDate: [null],
    });
  }

  getEduPackage() {
    this.eduPackageService.getList().subscribe(
      res => {
        this.eduPackageList = res.DataList;
      },
      err => {
        console.log(err);

      }
    );
  }
  getLevelInfo(e: MatSelect) {

    this.levelInfoService.getList(e.value).subscribe(
      res => {
        this.levelInfoList = res.DataList;
      },
      err => {
        console.log(err);

      }
    );
  }
  getCompanyList() {
    this.companyService.list(0,0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  getBranchList(company) {


    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        company
      );

    this.branchService.listByCompanyHeader(0, 0, headers).subscribe(res => {
      this.branchList = res.DataList;
    });


    // this.branchService.listByLogin(0, 0).subscribe(res => {
    //   this.branchList = res.DataList;
    // });
  }

  setCid(e: MatSelect) {
    //this.cidService.setCID(e.value);
    this.getBranchList(e.value);
  }

  // setBid(e: MatSelect) {
  //   //this.bidService.setBID(e.value);
  // }

  submit(data: any) {
    console.log(data);

    this.dialog.close(data);
  }

  onNoClick() {
    this.dialog.close();
  }


}
